import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  heightValue?: string;
  topValue?: string;
  smallArrows?: boolean;
}

export const Root = styled.div`
  position: relative;
  width: 100%;
  height: ${(props: IRootProps) => (props.heightValue ? props.heightValue : 'auto')};
`

export const Swipeable = styled.div`
  display: flex;
  margin: 0px 15px 0px 15px;
  padding: 5px 15px 5px 15px;
  width: calc(100% - 60px);
  height: 100%;
  overflow: hidden;
  .group-list {
    display: flex;
  }
`

export const ArrowLeftContainer = styled.div`
  z-index: 70;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${(props: IRootProps) => (props.smallArrows ? "23px" : '36px')};
  height: ${(props: IRootProps) => (props.smallArrows ? "23px" : '36px')};
  border-radius: 18px;
  box-shadow: 4px 4px 20px 0 rgba(0, 0, 0, 0.05);
  cursor: pointer;
  position: absolute;
  top: ${(props: IRootProps) => (props.topValue ? props.topValue : '0px')};
  left: -5px;
  background-color: ${C.WHITE};
  &:hover {
    background-color: ${C.LIGHTER_GRAY};
  }
`

export const ArrowRightContainer = styled.div`
  z-index: 70;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${(props: IRootProps) => (props.smallArrows ? "23px" : '36px')};
  height: ${(props: IRootProps) => (props.smallArrows ? "23px" : '36px')};
  border-radius: 18px;
  box-shadow: 4px 4px 20px 0 rgba(0, 0, 0, 0.05);
  cursor: pointer;
  position: absolute;
  top: ${(props: IRootProps) => (props.topValue ? props.topValue : '0px')};
  right: -5px;
  background-color: ${C.WHITE};
  &:hover {
    background-color: ${C.LIGHTER_GRAY};
  }
`

export const ArrowScale = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  transform: ${(props: IRootProps) => (props.smallArrows ? "scale(1)" : 'scale(1.5)')};
`